<div class="new-manager day-sessions-dialog">
  <div class="main-new-manager">
    <!-- Header con fecha y botón cerrar -->
    <div class="dialog-header">
      <h1 class="title-new-manager">{{ formattedDate }}</h1>
      <button type="button" class="btn-close" (click)="close()" tabindex="-1">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>

    <!-- Lista de sesiones -->
    <div class="sessions-list">
      <div
        class="session-item"
        *ngFor="let sessionData of sessions"
        [class.not-editable]="!canEditSession(sessionData)"
        [class.session-current]="canEditSession(sessionData)"
        (click)="editSession(sessionData)">
        <div class="session-content">
          <span class="session-time">{{ sessionData.session?.id_event ? (sessionData.session?.start_date | date:'HH:mm':'+0000') : (sessionData.session?.start_date | date:'HH:mm':'':'es') }}</span>
          <span class="session-title">{{ sessionData.event.title }}</span>
        </div>
        <button type="button" class="btn-edit" *ngIf="canEditSession(sessionData)" tabindex="-1">
          <i class="fa-regular fa-pen"></i>
        </button>
      </div>

      <!-- Mensaje si no hay sesiones -->
      <div class="no-sessions" *ngIf="sessions.length === 0">
        <p>No hay sesiones programadas para este día</p>
      </div>
    </div>
  </div>
</div>
